import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
//import {FormControl} from '@angular/forms';

/**
 * @title Require an autocomplete option to be selected
 */
@Component({
    selector: 'dbm-autocomplete',
    template: require('./dbm-autocomplete.component.html'),
    styles: [ require('./dbm-autocomplete.component.scss') ]
})
export class DbmAutocompleteComponent {
  @Input() public options: IACOption[];
  @Output() newTextEvent = new EventEmitter<string>(); //event emitter for new text typed
  @Output() selectedOptionEvent = new EventEmitter<IACOption>(); //event emitter for selected option
  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @Input() public text: string;
  @Input() public placeholder: string = "Search text";
  filteredOptions: IACOption[];

  constructor() {
    
    this.filteredOptions = this.options?.slice();
    
  }

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    
    try{
      this.filteredOptions = this?.options?.filter(o => o.name.toLowerCase().match(filterValue));
    }catch{};

    this.newTextEvent.emit(filterValue);
  }

  selectedOption(option: IACOption): void {
    this.selectedOptionEvent.emit(option);
    this.input.nativeElement.value = option.name;
  }

  loaded : boolean = false;
  ngAfterContentInit() {
    this.loaded = true;
  }

  ngOnChanges(){
    if(this.loaded)
    {
      //document.getElementById('input').focus();
    }
  }
}
//Interface to define the options for the autocomplete
export interface IACOption {
  id: number;
  name: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/dbm-autocomplete/dbm-autocomplete.component.ts